import { msg } from '@gonfalon/messages/msg';

import type { Metric } from './types';

export const EVENT_LEVEL_UNIT_AGGREGATION_TYPE = 'event_level';

export const EVENT_LEVEL_PERCENTILE_PRESETS = [50, 75, 90, 95, 99] as const;

export const DEFAULT_EVENT_LEVEL_PERCENTILE = 50;

export const MIN_EVENT_LEVEL_PERCENTILE = 1;

export const MAX_EVENT_LEVEL_PERCENTILE = 99;

export function isEventLevelPercentileMetric(metric: {
  unitAggregationType?: Metric['unitAggregationType'] | typeof EVENT_LEVEL_UNIT_AGGREGATION_TYPE;
}): boolean {
  return `${metric.unitAggregationType}` === EVENT_LEVEL_UNIT_AGGREGATION_TYPE;
}

export function isEventLevelPercentilePreset(value: number | undefined): boolean {
  return EVENT_LEVEL_PERCENTILE_PRESETS.some((preset) => preset === value);
}

export function isValidEventLevelPercentile(value: unknown): value is number {
  return (
    typeof value === 'number' &&
    Number.isInteger(value) &&
    value >= MIN_EVENT_LEVEL_PERCENTILE &&
    value <= MAX_EVENT_LEVEL_PERCENTILE
  );
}

export function validateEventLevelPercentile(value: unknown): true | string {
  return isValidEventLevelPercentile(value) || msg('metrics.metricDefinition.percentileLevelInvalid');
}

export function parseEventLevelPercentileInput(input: string): number | undefined {
  const trimmed = input.trim();
  if (trimmed === '') {
    return undefined;
  }
  return /^\d+$/.test(trimmed) ? Number(trimmed) : Number.NaN;
}
